import React from "react";
import ReactModal from "react-modal";
import "./TopupModal.css";
import { useLanguage } from "../../i18n/LanguageContext";

const formatIDR = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

const IcClose = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="#595959" strokeWidth="2" strokeLinecap="round" />
    </svg>
);
const IcClock = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="#8c8c8c" strokeWidth="2" />
        <path d="M12 7v5l3 2" stroke="#8c8c8c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
const IcChevron = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <polyline points="9 6 15 12 9 18" stroke="#237804" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const TopupModal = ({
    isOpen,
    onClose,
    loading = false,
    options = [],
    onChoose, // (option) => void
    title,
    subtitle,
}) => {
    const { t } = useLanguage();
    // An explicit empty subtitle hides the line, as before; omitted uses the default.
    const sub = subtitle ?? t("topupModal.subtitle");
    const sortedOptions = [...options].sort((a, b) => (a.gb || 0) - (b.gb || 0));

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="tu-sheet"
            overlayClassName="tu-overlay"
            ariaHideApp={false}
            shouldCloseOnOverlayClick
        >
            <div className="tu-grip" aria-hidden="true" />

            <div className="tu-head">
                <div className="tu-head-text">
                    <h3 className="tu-title">{title || t("topupModal.title")}</h3>
                    {sub && <p className="tu-sub">{sub}</p>}
                </div>
                <button className="tu-close" onClick={onClose} aria-label={t("common.close")}>
                    <IcClose />
                </button>
            </div>

            <div className="tu-body">
                {loading ? (
                    <div className="tu-list" aria-busy="true">
                        {[0, 1, 2].map((i) => <div key={i} className="tu-skel" />)}
                    </div>
                ) : sortedOptions.length === 0 ? (
                    <div className="tu-empty">{t("topupModal.empty")}</div>
                ) : (
                    <div className="tu-list">
                        {sortedOptions.map((opt, i) => (
                            <button
                                key={opt.code || i}
                                className="tu-option"
                                onClick={() => onChoose?.(opt)}
                            >
                                <div className="tu-option-main">
                                    <span className="tu-option-balance">{opt.balance}</span>
                                    <span className="tu-option-validity">
                                        <IcClock /> {t("topupModal.validity", { n: opt.validity })}
                                    </span>
                                </div>
                                <div className="tu-option-end">
                                    <span className="tu-option-price">{formatIDR(opt.price)}</span>
                                    <IcChevron />
                                </div>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </ReactModal>
    );
};

export default TopupModal;
